import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import GroupIcon from "@material-ui/icons/Group";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useLocation, useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";
 
const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(7),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%"
  }
}));

// Validate the JWT
// var token = "eyJ0eXAiO.../// jwt token";
// var decoded = jwt_decode(token);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


export default function SearchGolfer() {

  const history = useHistory();

  const classes = useStyles();
  const [firstLoad, setLoad] = React.useState(true);

  const [ghinNumber, setGhinNumber] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  
  const handleGhinNumberChange = event => {
    setGhinNumber(event.target.value);
  }
  const handlFirstNameChange = event => {
    setFirstName(event.target.value);
  }
  const handleLastNameChange = event => {
    setLastName(event.target.value);
  }
  
  const [message, setMessage] = React.useState("Nothing saved in the session");
  
  const [golfersResults, setGolferResults] = React.useState([]);

  async function sampleFunc(toInput) {
    console.dir(toInput);
    // toInput = '{"ghin":1106250,"associationid":53,"ghinclubid":23924,"email":"kameron.fudenna@gmail.com","birthdate":"4/6/2007","address":{"line1":"5512 Treasure Dr","line2":"","city":"Rocklin","state":"CA","postal_code":"95765","country":"USA"},"prefix":"","firstname":"Kameron","middlename":"","lastname":"Fudenna","suffix":"","gender":"M","membertype":"J"}';
    // toInput = JSON.parse(toInput);
    const response = await fetch("http://localhost:8080/searchGhinGolfer", {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json"
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      body: JSON.stringify(toInput) // body data type must match "Content-Type" header
    });
    let body = await response.json();
    console.dir(body);
    setGolferResults(body);
    setMessage(body.error ? "Search Failed" : "Search Successful");
  }

  // function ViewLink(props) {
  //   return <Link to={"/view?lastName=" + lastName}>View Employee Records</Link>
  // }

  const handleSubmit = event => {
    event.preventDefault();
    // const toInput = { ghin: ghinNumber, associationId: 53, firstName, lastName };
    // sampleFunc(toInput);
    // setGolferResults([]);
    if (validateForm()) {
      let queryParams = `lastName=${lastName}&firstName=${firstName}&ghinNumber=${ghinNumber}`;
      if (!!token && token.trim().length > 0 && token != "null") {
        queryParams += `&token=${token}`;
      }
      if (!!courseId) {
        queryParams += `&courseId=${courseId}`;
      }
      history.push(`/view?${queryParams}`);
    }
  };

  const validateForm = () => {
    return (!!lastName && lastName.trim().length > 0)// || firstName || ghinNumber);
    || (!!ghinNumber && parseInt(ghinNumber) > 0);// || firstName || ghinNumber);
  }

  let query = useQuery();
  const token = query.get("token");
  const courseId = query.get("courseId");
  let decoded;
  try {
    decoded = jwt_decode(token);
    console.dir(decoded);
  } catch(e) {
    console.dir(e);
  }
  // if (!decoded) {
  //   return (
  //     <Container component="main" maxWidth="lg">
  //     <CssBaseline />
  //     <div className={classes.paper}>
  //       <Avatar className={classes.avatar}>
  //         <GroupIcon />
  //       </Avatar>
  //       <Typography component="h1" variant="h5">
  //         Search GHIN Golfers
  //       </Typography>
  //     </div>
  //   </Container>
  //   );
  // }

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <GroupIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Search GHIN Golfers
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required={!lastName || lastName.trim().length === 0}
                fullWidth
                id="ghinNumber"
                value={ghinNumber}
                label="GHIN Number"
                name="ghinNumber"
                autoComplete="ghinNumber"
                onChange={handleGhinNumberChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="firstName"
                name="firstName"
                variant="outlined"
                fullWidth
                value={firstName}
                id="firstName"
                label="First Name"
                onChange={handlFirstNameChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required={!ghinNumber || parseInt(ghinNumber) <= 0}
                fullWidth
                id="lastName"
                value={lastName}
                label="Last Name"
                name="lastName"
                autoComplete="lastName"
                onChange={handleLastNameChange}
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={!validateForm()}
            className={classes.submit}
          >
            Search
          </Button>
        </form>
      </div>
    </Container>
  );
}